import axios from 'axios'
window.axios = axios
function getCookie(name) {
  let matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`
  ))
  return matches ? decodeURIComponent(matches[1]) : undefined
}

export default class Api {
  constructor(base, contentType) {
    this.base = base
    this.contentType = contentType
    return axios.create({
      baseURL: this.base,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRFToken": getCookie("csrftoken"),
        "Content-Type": this.contentType
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/services/api.js